/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ValidateInstrumentLinkErrorCodeRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/ValidateInstrumentLinkErrorCode.pb'
import {ValidateInstrumentLinkErrorCodeResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/ValidateInstrumentLinkErrorCode.pb'


export const validateInstrumentLinkErrorCode = (request: ValidateInstrumentLinkErrorCodeRequest, options?: CashRequestOptions) => post<ValidateInstrumentLinkErrorCodeRequest, ValidateInstrumentLinkErrorCodeResponse>("/2.0/cash/validate-instrument-link-error-code", request, {...options, rejectOnError: true })